export class InvoiceAddendumListViewModel {
    public uploadedDate: Date;
    public addendumTotalCount: number;
}

export class InvoiceHistoryDate{
    constructor(dta: any){
        this.year = dta.item1;
        this.month = dta.item2;
    }
    public year : number;
    public month : number;
}


export class InvoiceAddendum {
    Id: number;
    ApplicantFirstName: string;
    ApplicantLastName: string;
    ScreeningDate: Date | string;
    ProductName: string;
    PropertyId: number;
    BasePrice: number;
    UploadedDate: Date | string | null;
    InvoiceNumber: number | null;
    ReportLevelAddendum: boolean;
}